import { render, staticRenderFns } from "./InspectionRelated.vue?vue&type=template&id=78e2d34c&scoped=true&"
import script from "./InspectionRelated.vue?vue&type=script&lang=ts&"
export * from "./InspectionRelated.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionRelated.vue?vue&type=style&index=0&id=78e2d34c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e2d34c",
  null
  
)

export default component.exports